"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormDueInDaysEnum = void 0;
var FormDueInDaysEnum;
(function (FormDueInDaysEnum) {
    FormDueInDaysEnum[FormDueInDaysEnum["DATE_RANGE"] = 1] = "DATE_RANGE";
    FormDueInDaysEnum[FormDueInDaysEnum["DAY_RANGE"] = 2] = "DAY_RANGE";
})(FormDueInDaysEnum || (exports.FormDueInDaysEnum = FormDueInDaysEnum = {}));
